export enum DateTimeEnum {
  FULLDAY = "Full Day",
  INVALIDDATE = "Invalid Date",
}
